var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "10 3 24 25",
    style: {
      enableBackground: "new 0 0 43 32.25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M33.51,7.22H10.55c-0.24,0-0.43,0.19-0.43,0.43c0,0.24,0.19,0.43,0.43,0.43h22.96c0.24,0,0.43-0.19,0.43-0.43 C33.93,7.42,33.74,7.22,33.51,7.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M33.51,15.24H10.55c-0.24,0-0.43,0.19-0.43,0.43c0,0.24,0.19,0.43,0.43,0.43h22.96c0.24,0,0.43-0.19,0.43-0.43 C33.93,15.43,33.74,15.24,33.51,15.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M33.51,23.26H10.55c-0.24,0-0.43,0.19-0.43,0.43s0.19,0.43,0.43,0.43h22.96c0.24,0,0.43-0.19,0.43-0.43 S33.74,23.26,33.51,23.26z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.cd3e0eebfc10f71ec9539a1102c0b437.svg";
export { ForwardRef as ReactComponent };